export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádost o technickou podporu"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["od"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přidat zprávu"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soubory"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Můžete nahrát jeden nebo více souborů. Maximální velikost souboru je 10 MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Text zprávy"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat"])}
}